export const DEFAULT_BRIDAL_FAIR_PAGES_THANKS_MESSAGE =
  'ご予約いただき誠にありがとうございます。\nフェアの予約を承りました。\n\n当日のご来館をお待ちしております。\nご予約内容の変更やキャンセルをご希望の場合は直接お電話にてご連絡をお願いいたします。'
